/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SqlQueryExecution } from '../models/SqlQueryExecution';

export class ListSqlQueryExecutionsResponse {
  /**
  * List of SQL query executions
  */
  'sqlQueryExecutions': Array<SqlQueryExecution>;
  /**
  * Token for fetching the next page of results
  */
  'nextToken'?: string | null;
  /**
  * Total number of query executions matching the filters
  */
  'totalCount'?: number | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sqlQueryExecutions",
      "baseName": "sqlQueryExecutions",
      "type": "Array<SqlQueryExecution>",
      "format": ""
    },
    {
      "name": "nextToken",
      "baseName": "nextToken",
      "type": "string",
      "format": ""
    },
    {
      "name": "totalCount",
      "baseName": "totalCount",
      "type": "number",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListSqlQueryExecutionsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

